import { render, staticRenderFns } from "./SamplesDiagnosis.vue?vue&type=template&id=c230ab0e&"
import script from "./SamplesDiagnosis.vue?vue&type=script&lang=js&"
export * from "./SamplesDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./SamplesDiagnosis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports